import { render, staticRenderFns } from "./PurchasingStatus.vue?vue&type=template&id=fcf1b35c&"
import script from "./PurchasingStatus.vue?vue&type=script&lang=js&"
export * from "./PurchasingStatus.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingStatus.vue?vue&type=style&index=0&id=fcf1b35c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports